
import { LucideIcon } from 'lucide-react';
import { weightLossMedications } from './weight-loss';
import { mensHealthMedications } from './mens-health';
import { womensHealthMedications } from './womens-health';
import { peptidesMedications } from './peptides';
import { injectablesMedications } from './injectables';
import { additionalMedications } from './additional';

export interface ClinicalDetails {
  dosingGuidelines: string;
  administrationProtocols: string;
  contraindications: string;
  monitoringRequirements: string;
}

export interface AdverseReactions {
  common: string;
  lessCommon: string;
  rare: string;
}

export interface Medication {
  id: string;
  name: string;
  description: string;
  research: string;
  url: string;
  category: 'weight-loss' | 'mens-health' | 'womens-health' | 'peptides' | 'injectables' | 'additional';
  Icon: LucideIcon;
  video?: string;
  clinicalDetails?: ClinicalDetails;
  availablePreparations?: string;
  adverseReactions?: AdverseReactions;
}

export const medications: Medication[] = [
  ...weightLossMedications,
  ...mensHealthMedications,
  ...womensHealthMedications,
  ...peptidesMedications,
  ...injectablesMedications,
  ...additionalMedications
];

export const categoryNames = {
  'weight-loss': 'Weight Loss Medications',
  'mens-health': 'Men\'s Health and Hormones',
  'womens-health': 'Women\'s Health and Hormones',
  'peptides': 'Peptides and Anti-Aging',
  'injectables': 'Other Injectable Compounds',
  'additional': 'Additional Medications'
};
